import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { LoginScreen } from './features/auth/LoginScreen';
import { ProjectsList } from './features/projects/ProjectsList';
import { ProjectDetail } from './features/project-detail/ProjectDetail';
import { TokenSettings } from './features/tokens/TokenSettings';
import { AppShell } from './components/AppShell';

export function App() {
  const { token } = useAuth();

  if (!token) {
    return (
      <Routes>
        <Route path="*" element={<LoginScreen />} />
      </Routes>
    );
  }

  return (
    <AppShell>
      <Routes>
        <Route path="/" element={<ProjectsList />} />
        <Route path="/projects/:projectKey" element={<ProjectDetail />} />
        <Route path="/settings" element={<TokenSettings />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
